import React, { useEffect, useRef } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import '../css/NotFound.css';

const NotFound = () => {
    const navigate = useNavigate();
    const hasRefreshed = useRef(false);

    useEffect(() => {
        // Only refresh once per mount
        if (!hasRefreshed.current) {
            hasRefreshed.current = true;
            window.location.reload();
        } else {
            // Already refreshed for this mount, redirect to home after 3 seconds
            const timer = setTimeout(() => {
                navigate("/", { replace: true });
            }, 3000);
            return () => clearTimeout(timer);
        }
    }, [navigate]);

    return (
        <div className="notfound-page">
            <div className="notfound-content">
                <div className="notfound-icon">
                    🔍
                </div>
                <div className="notfound-code">404</div>
                <h1 className="notfound-title">Page Not Found</h1>
                <p className="notfound-subtitle">
                    Oops! The page you're looking for doesn't exist or has been moved.
                </p>
                <p className="notfound-redirect">
                    <span className="spinner"></span>
                    Redirecting to home...
                </p>
                <Link to="/" className="notfound-cta">
                    Return to Home
                </Link>
            </div>
        </div>
    );
};

export default NotFound;
